import {
    Box, Container, Grid, Typography, IconButton, Button
} from "@mui/material";
import fullLogo from '../../Assets/Images/Company-fulllogo.png';
import { useNavigate } from "react-router-dom";

// import XIcon from '@mui/icons-material/X';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

const menuItems = [
    { id: 0, label: "Home", path: "/" },
    { id: 1, label: "About", path: "/about" },
    { id: 2, label: "Why Choose Us", path: "/why-choose-us" },
    { id: 3, label: "Where We Build", path: "/where-we-build" },
    { id: 4, label: "Projects", path: "/gallery" },
    { id: 5, label: "Accessibility", path: "/accessibility" },
    { id: 6, label: "Contact Us", path: "/contact" },
];

const legalItems = [
    { id: 1, label: "Terms & Conditions", path: "/terms-and-conditions" },
    { id: 2, label: "Privacy Policy", path: "/privacy-policy" },
];

const socialLinks = [
    { icon: FacebookIcon, href: "https://www.facebook.com/ClarencehomesNSW/" },
    { icon: InstagramIcon, href: "https://www.instagram.com/clarencehomes/" },
    // { icon: XIcon, href: "https://x.com/clarencehomes" },
    // { icon: LinkedInIcon, href: "#" },
];

function Footer() {
    const navigate = useNavigate();

    const navBtn = (item) => (
        <Button
            key={item.id}
            onClick={() => navigate(item.path)}
            variant="text"
            sx={{
                textTransform: "none",
                fontWeight: 500,
                color: "rgba(255,255,255,0.8)",
                justifyContent: 'flex-start',
                px: 0,
                minWidth: 0,
                fontSize: '14px',
                transition: 'color 0.3s ease',
                "&:hover": {
                    color: "var(--primary-text-color)",
                    backgroundColor: "transparent",
                },
            }}
        >
            {item.label}
        </Button>
    );

    return (
        <Box sx={{ backgroundColor: "var(--primary-color)", color: "#fff", pt: 7, pb: 0, mt: 5 }}>
            <Container maxWidth="xl">
                <Grid container spacing={5} justifyContent="space-between">

                    {/* Col 1 — Logo & tagline */}
                    <Grid item xs={12} md={4}>
                        <Box component="img" src={fullLogo} height="130px" sx={{ mb: 2 }} />
                        <Typography variant="body2" sx={{ opacity: 0.75, lineHeight: 1.8, maxWidth: 320 }}>
                            We build high-quality custom homes with precision,
                            creativity, and trust. Let's create something amazing together.
                        </Typography>
                        {/* Social icons */}
                        <Box sx={{ mt: 3, display: 'flex', gap: 1 }}>
                            {socialLinks.map(({ icon: Icon, href }, i) => (
                                <IconButton
                                    key={i}
                                    component="a"
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        color: "#fff",
                                        border: '1px solid rgba(255,255,255,0.25)',
                                        borderRadius: '6px',
                                        p: '7px',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: 'var(--primary-text-color)',
                                            borderColor: 'var(--primary-text-color)',
                                            color: 'var(--primary-color)',
                                        }
                                    }}
                                >
                                    <Icon size={18} />
                                </IconButton>
                            ))}
                        </Box>
                    </Grid>

                    {/* Col 2 — Quick Links */}
                    <Grid item xs={6} md={2}>
                        <Typography sx={{ fontWeight: 700, fontSize: '15px', mb: 2, color: 'var(--primary-text-color)', letterSpacing: 1, textTransform: 'uppercase' }}>
                            Quick Links
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            {menuItems.map(navBtn)}
                        </Box>
                    </Grid>

                    {/* Col 3 — Legal */}
                    <Grid item xs={6} md={2}>
                        <Typography sx={{ fontWeight: 700, fontSize: '15px', mb: 2, color: 'var(--primary-text-color)', letterSpacing: 1, textTransform: 'uppercase' }}>
                            Legal
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            {legalItems.map(navBtn)}
                        </Box>
                    </Grid>

                    {/* Col 4 — Contact */}
                    <Grid item xs={12} md={3}>
                        <Typography sx={{ fontWeight: 700, fontSize: '15px', mb: 2, color: 'var(--primary-text-color)', letterSpacing: 1, textTransform: 'uppercase' }}>
                            Contact
                        </Typography>
                        {[
                            { label: 'Email', value: 'info@clarencehomes.com.au', href: 'mailto:info@clarencehomes.com.au' },
                            { label: 'Phone', value: '1300 451 780', href: 'tel:1300451780' },
                            { label: 'Location', value: '14a/18 Third Ave, Blacktown NSW 2148, Australia', href: null },
                        ].map(({ label, value, href }) => (
                            <Box key={label} sx={{ mb: 1.5 }}>
                                <Typography sx={{ fontSize: '11px', color: 'var(--primary-text-color)', fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase' }}>{label}</Typography>
                                <Typography
                                    component={href ? 'a' : 'p'}
                                    href={href || undefined}
                                    sx={{ fontSize: '14px', width: '15rem', color: 'rgba(255,255,255,0.8)', textDecoration: 'none', m: 0, ...(href && { cursor: 'pointer', '&:hover': { color: 'var(--primary-text-color)' } }) }}
                                >
                                    {value}
                                </Typography>
                            </Box>
                        ))}
                    </Grid>

                </Grid>

                {/* Bottom bar */}
                <Box sx={{
                    mt: 6, py: 2.5,
                    borderTop: '1px solid rgba(255,255,255,0.12)',
                    display: 'flex', flexWrap: 'wrap',
                    alignItems: 'center', justifyContent: 'space-between', gap: 1
                }}>
                    <Typography sx={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)' }}>
                        © {new Date().getFullYear()} Clarence Homes. All Rights Reserved.
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 3 }}>
                        {legalItems.map(item => (
                            <Typography
                                key={item.id}
                                onClick={() => navigate(item.path)}
                                sx={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', '&:hover': { color: 'var(--primary-text-color)' } }}
                            >
                                {item.label}
                            </Typography>
                        ))}
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;
